import { Grid } from "@material-ui/core";
import Controls from "../../../../components/controls/Controls";
import FormBase from "../../../../forms/FormBase";
import BusinessDataForm from "../../../../forms/shared/BusinessForm";
import { InputType } from "../../../../components/controls/Input";


interface IBusinessDataComponentProps {
    BusinessDataForm: BusinessDataForm,
    onInputChange: (name: string, form: FormBase, value: any) => void
}


export default function BusinessDataComponent(props: IBusinessDataComponentProps) {

    return (
        <div>
            <Grid container spacing={5}>
                <Grid item xs={6} sm={6}>
                    <Controls.Input name="Name" label="Nome" maxLength={100} placeholder="Digite o nome da empresa" value={props.BusinessDataForm.Name.Value}
                        onChange={(e) => {
                            props.onInputChange("Name", props.BusinessDataForm, e.target.value);
                        }}
                        onBlur={(e) => {
                            props.onInputChange("Name", props.BusinessDataForm, e.target.value);
                        }}
                        error={props.BusinessDataForm.Name.Error}
                        mandatory={props.BusinessDataForm.Name.Mandatory}
                    />
                </Grid>

                <Grid item xs={6} >
                    <Controls.Input name="CNPJ" label="CNPJ" maxLength={18} type={InputType.CNPJ} placeholder="__.___.___/____-__"
                        value={props.BusinessDataForm.CNPJ.Value}
                        onChange={(e) => {
                            props.onInputChange("CNPJ", props.BusinessDataForm, e.target.value);
                        }}
                        onBlur={(e) => {
                            props.onInputChange("CNPJ", props.BusinessDataForm, e.target.value);
                        }}
                        error={props.BusinessDataForm.CNPJ.Error}
                        mandatory={props.BusinessDataForm.CNPJ.Mandatory}
                    />
                </Grid>
            </Grid>
        </div>
    );
}